// import { useKeenSlider } from 'keen-slider/react' // import from 'keen-slider/react.es' for to get an ES module
import { Button, createStyles, useMantineTheme } from "@mantine/core";
import ProductCard, { ProductCardProp } from "./product-card";
import { ChevronLeft, ChevronRight } from "tabler-icons-react";
import { Carousel as MantineCarousel } from '@mantine/carousel';
import React from 'react';

const useStyles = createStyles((theme) => ({
    Carousel: {
        marginTop: 40,
        display: 'flex',
        flexDirection: 'row',
        [theme.fn.smallerThan('md')]: {
            width: '60vw !important',
        },
        [theme.fn.largerThan('md')]: {
            width: '60vw !important',
        },
    },
    indexor: {
        height: 7,
        backgroundColor: 'grey',
        '&:active': {
            backgroundColor: theme.colors.hkc[1],
            opacity: 1
        },
        '&[data-active]':{
            backgroundColor: theme.colors.hkc[1],
            opacity: 1
        }
    },

    mobileInactive: {
        [theme.fn.smallerThan('md')]: {
            display: 'none'
        },
        [theme.fn.largerThan('md')]: {
            display: 'flex'
        }
    },

    carouselContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center'
    },
}))

const Carousel = (prop: { photos: ProductCardProp[] }): JSX.Element => {
    const { classes } = useStyles()
    const theme = useMantineTheme()
    return (
        <>
            <div className={classes.carouselContainer}>
                <MantineCarousel
                    mt={15}
                    height={340}
                    slideSize="30%"
                    slideGap="md"
                    loop
                    nextControlIcon={<ChevronRight size={30} color={theme.colors.hkc[0]}/>}
                    previousControlIcon={<ChevronLeft size={30} color={theme.colors.hkc[0]}/>}
                    style={{ width: '100%' }}
                    dragFree
                    breakpoints={[
                        { maxWidth: 'md', slideSize: '50%' },
                        { maxWidth: 'sm', slideSize: '100%', slideGap: 0 },
                    ]}
                >
                    {prop.photos.map((photo, idx) => (
                        <MantineCarousel.Slide>
                            <ProductCard key={photo.slug} prop={photo} />
                        </MantineCarousel.Slide>
                    ))}
                </MantineCarousel>
            </div>
        </>
    )
}

export default Carousel